import axios from "axios";

axios.defaults.baseURL = process.env.APP_URL;

export default axios;
